import React, { Component } from 'react';
import {withTranslation} from 'react-i18next';
import { callGET,callDELETE,callPOST } from '../../../Utils/ApiUtil';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import Wrp from "../../../hoc/Wrp/Wrp";
import TableRecord from "../../../Components/UI/TableRecord";
import CreateNew from './CreateNew';
import { getCurrentModuleId } from '../../../Utils/UserFunctions';
import * as ShipConstants from '../../../Global/Constants';
import {getValueFromOptions} from '../../../Utils/CommonFunctions';
import HtmlPdfPReview from '../HtmlPdfPReview';

class PDFList extends Component {

	state = {
      isModalOpen:false,
      isVariableTemplate:true,
      createPDFModalOpen:false,
      isPreviewModalOpen:false,
      modal: false,
      breadCrumbs:this.props.breadCrumbs,
      page:this.props.page,
      selectedId:null,
      editData : {
        id : null
      },
      pdfCreationList : [],
      windowList:[],
      screen:'new',
      pdfDetail:{
        id : null,
        designName : '',
        description : '',
        isActive : true,
        isDefault : true,
        htmlContent : '',
        iterateData : {},
        format:'A4',
        width:210,
        height:297,
        formatOptions: [{value:'A0',label:'A0',width:841,height:1189},{value:'A1',label:'A1',width:594,height:841},{value:'A2',label:'A2',width:420,height:594},{value:'A3',label:'A3',width:297,height:420},{value:'A4',label:'A4',width:210,height:297},{value:'A5',label:'A5',width:148,height:148},{value:'Letter',label:'Letter',width:216,height:279},{value:'Legal',label:'Legal',width:216,height:330},{value:'Tabloid',label:'Tabloid',width:841,height:1189},{value:'Custom',label:'Custom',width:0.00,height:0.00}],
        designName_error:'',
        is_window:false,
        window_id:''
      },
      tableRecords:{
        tableHead:[
          {
            name:"Action",
            type:"Actions",
            isShow:true,
            attributes:{style:{width: "75px"}}
          },
          {
            name:"PDF Name",
            type:"Setting",
            clickHandler:"",
            isShow:true,
            attributes:{
            }
          },
          {
            name:"Window Name",
            type:"HyperLink",
            clickHandler:"",
            isShow:true,
            attributes:{
            }
          },
          {
            name:"Description",
            type:"HyperLink",
            clickHandler:"",
            isShow:true,
            attributes:{
            }
          },
          {
            name:"Is Active",
            type:"Status",
            clickHandler:"",
            isShow:true
          },
          {
            name:"Is Default",
            type:"Status",
            clickHandler:"",
            isShow:true
          },
          {
            name:"HTML Content",
            type:"HyperLink",
            clickHandler:"",
            isShow:true,
            attributes:{
            }
          }
        ],
        tableData:[], 
        pagination:{
          page:0,
          orderBy:'',
          perPage:10,
          direction:'ASC',
          totalRecords:0,
          search:''
        }
      }
    }

    componentWillMount() {
	    const params = this.props.match.params;
	    this.pdfCreationList(this.state.tableRecords.pagination,1);
      this.windowsList();
	    this.setState({
	      breadCrumbs: {
	          backHistory : [{
	          href : "/settings",
	          name:"Settings"
	          }],
	          pageTitle:"PDF Template List",
	          buttonList:[
	          {
	              clickHandler:this.toggleCreatePDfModel,
	              attributes:{
	                className:"btn primary_bg"
	              },
	              name:"Add New",
	              type:"addNew"
	          }
	          ]
	      }
	    });
	  }

    toggleTab = (type) => {
      this.setState({
        isVariableTemplate:type,
        tableRecords:{
          ...this.state.tableRecords,
          pagination:{
            page:0,
            orderBy:'',
            perPage:10,
            direction:'ASC',
            totalRecords:0,
            search:''
          }
        }
      })
      setTimeout(() => {
        this.pdfCreationList(this.state.tableRecords.pagination,1);
      }, 300); 
    }

	render(){
    const params = this.props.match.params;
      return (
        <Wrp>
          <BreadCrumbs 
            breadCrumbsList={this.state.breadCrumbs} 
            />
            <ul className="nav nav-pills navcrm-primary nav-pills-no-bd fixed-2" role="tablist">
                  <li className="nav-item"> <a onClick={e=>this.toggleTab(true)} className={this.state.isVariableTemplate === true ? "nav-link active show" : "nav-link show" } data-toggle="tab" href="#variableTemplate" role="tab" aria-selected="true">Variable Template</a> 
                  </li>
                  <li className="nav-item"> <a onClick={e=>this.toggleTab(false)} className={this.state.isVariableTemplate !== true ? "nav-link active show" : "nav-link show" } data-toggle="tab" href="#windowTemplate" role="tab" aria-selected="false">Window Template</a> 
                  </li> 
              </ul>
            <div className="viewport">
              <div className="view view-xl">
              
                <div className="outerPort">
                   
                  <TableRecord 
                    tableRecords={this.state.tableRecords} 
                    recordsChangeHandler={this.pdfCreationList}
                  />
                       
                </div>   
              </div>
            </div> 
            <CreateNew
              toggleCreatePDfModel={this.toggleCreatePDfModel}
              createPDFModalOpen={this.state.createPDFModalOpen}
              savePDFHandler={this.savePDFHandler}
              createPDFChangeHandler={this.createPDFChangeHandler}
              pdfData={this.state.pdfDetail}
              windowList={this.state.windowList}
            />
            <HtmlPdfPReview 
              isModalOpen={this.state.isPreviewModalOpen} 
              toggleHandler={this.previewToggleHandler}
              pdfCreationList={this.state.pdfCreationList}
              selectedId ={this.state.selectedId}
              selectTemplate={this.selectTemplate}
              previewScreen="list"
            />
        </Wrp>
      );
    }

  previewToggleHandler = () => {
    this.setState({isPreviewModalOpen:!this.state.isPreviewModalOpen})
  }

  selectTemplate = (id) => {
    const updateState = { ...this.state };
    updateState.selectedId = id;
    this.setState(updateState);
  }

	pdfCreationList = (pagination,loader=0) => {
    const params = this.props.match.params;
    const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    this.setState({
      tableRecords:{
        ...this.state.tableRecords,
        pagination:pagination
      }
    })
    const queryString = '?keyword='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    this.props.Loader();
    callGET("htmltopdf-design/template-list/"+this.state.isVariableTemplate+"/"+queryString)
    .then(res => {
      const response = res.data;
      if(response.code===200){
        let updateTableData = [];
        let totalRecords = 0;
        let pdflist = [];
        if(response.data) {
          updateTableData = response.data.content.map((item,index)=>{
            return {
              className:'icon_hover cursor-pointer',
              rowId:"",
              data:{
                actions:[
                  {
                    clickHandler:this.editHandler.bind(this,item),
                    attributes:{
                      className:"p-1"
                    },
                    svgIcon:'Edit',
                    // iconClass:"fas fa-pencil-alt third_dark_color",
                    name:""
                  },
                  {
                    attributes:{
                      className:"p-1"
                    },
                    svgIcon:'Delete',
                    // iconClass:"fas fa-trash-alt primary_color",
                    clickHandler:this.deletePDFHandler.bind(this,item.id),
                    name:""
                  }
                ],
                name:{
                  value: item.design_name,
                  href:"/pdf-template/"+item.id,
                  param:{
                    data:{...item},
                  },
                  attributes:{
                    id: item.id
                  },
                  setting:{
                    attributes:{},
                    actionMore:[{
                        href:"",
                        attributes:{
                          className:"dropdown-item"
                        },
                        access_mode:true,
                        name:"Preview",
                        clickHandler:this.previewToggleHandler.bind(this,item.id),
                      },
                    ]
                  }
                },
                window_name:{
                  value:item.window_name
                },
                description:{
                  value:item.description
                },
                is_active:{
                  checked:item.is_active,
                  attributes:{}
                },
                is_default:{
                  checked:item.is_default,
                  attributes:{}
                },
                html_content:{
                  value :item.html_content
                }
              }
            }
              
          });
          totalRecords = response.data.total_elements;
          pdflist = response.data.content;
        }
        
        this.setState({status:200, pdfCreationList:pdflist, tableRecords:{
          tableData:{data:updateTableData,status:200},
          tableHead:this.state.tableRecords.tableHead ,
          pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
        }});
        this.props.Loader();
      }else{
        const totalRecords = 0;//response.data.totalElements;
        this.setState({status:200, tableRecords:{
          tableData:[],
          tableHead:this.state.tableRecords.tableHead ,
          pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
        }});
        this.props.Loader();
      }
    }, (error) => {
      // this.props.failMessage("Something went wrong..");
      this.props.Loader();
    })
    .catch(err => {
        console.log(err);
        this.props.Loader();
    })
  }
	//DELETE LAYOUT RECORD
  deletePDFHandler = (id) => {
    // let cfrm = window.confirm("Are you sure want to remove this data ?");
    // if(cfrm===true){
      this.props.Loader();
      callDELETE('htmltopdf-design/'+id+'/delete')
        .then((response) => {
          this.props.Loader();
          this.props.succMessage((response.data.message)?response.data.message:'data Removed successfully');
          this.pdfCreationList(this.state.tableRecords.pagination,1);
        }, (error) => {
          console.log(error);
          this.props.failMessage("Something went wrong while removing data");
        });
    // } 
  }

  toggleHandler = (id) => {
    const updateState = { ...this.state };
    updateState.isModalOpen = !this.state.isModalOpen;
    if(id){
      updateState.selectedId = id;
    }
    this.setState(updateState);
  }

  toggleCreatePDfModel=()=>{
    this.setState({
      createPDFModalOpen:!this.state.createPDFModalOpen,
      ...this.state.pdfDetail,
      pdfDetail:{
        id : null,
        designName : '',
        description : '',
        isActive : true,
        isDefault : true,
        htmlContent : '',
        iterateData : {},
        format:'A4',
        width:210,
        height:297,
        formatOptions: [{value:'A0',label:'A0',width:841,height:1189},{value:'A1',label:'A1',width:594,height:841},{value:'A2',label:'A2',width:420,height:594},{value:'A3',label:'A3',width:297,height:420},{value:'A4',label:'A4',width:210,height:297},{value:'A5',label:'A5',width:148,height:148},{value:'Letter',label:'Letter',width:216,height:279},{value:'Legal',label:'Legal',width:216,height:330},{value:'Tabloid',label:'Tabloid',width:841,height:1189},{value:'Custom',label:'Custom',width:0.00,height:0.00}],
        designName_error:''
      }
    })
  }

  createPDFChangeHandler = (e) => {
    const {name,value} = e.target;
    const updateState = {...this.state};
    let val = value;
    if(name === "isActive" || name === "isDefault" || name === "is_window") {
      val = e.target.checked;
    }

    if(name==="format") {
      const optionVal = getValueFromOptions(value,this.state.pdfDetail.formatOptions);
      if(optionVal) {
        updateState.pdfDetail['width'] = optionVal.width;
        updateState.pdfDetail['height'] = optionVal.height;
      }
    }else if(name === "designName") {
      updateState.pdfDetail['designName_error'] = "";
    }
    updateState.pdfDetail[name]=val;
    console.log(updateState.pdfDetail);
    this.setState(updateState);
  }

  savePDFHandler=()=>{
    this.props.Loader();
    const {pdfDetail} = this.state;
    const body = {
      id:pdfDetail.id,
      design_name: pdfDetail.designName,
      description: pdfDetail.description,
      is_active: pdfDetail.isActive,
      is_default: pdfDetail.isDefault,
      format: pdfDetail.format,
      width: pdfDetail.width,
      height: pdfDetail.height,
      window_id:pdfDetail.window_id,
      is_variable_mapping:!pdfDetail.is_window,
      module_id: getCurrentModuleId()
    }
    // console.log(JSON.stringify(body));
    const header = { 'Content-Type': 'application/json' }

    callPOST("htmltopdf-design/create",body,header)
      .then(response => {
        this.props.Loader();
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.succMessage(responseData.message);
          this.toggleCreatePDfModel();
          this.pdfCreationList(this.state.tableRecords.pagination,1);
        }else {
          this.setState({
            pdfDetail:{
              ...this.state.pdfDetail,
              designName_error:"must not be blank"
            }
          })
          // let violations = responseData.violations;
          // let errMsg = [responseData.message];
          //   if(violations.length > 0){
          //     const data = {...pdfdata};
          //   violations.map((item,ind) => {
          //     data[item['field_name']+'_error'] = item['message'];
          //         errMsg.push(item['field_name']+' : '+item['message'])
          //     })
          // }
        }
      })
      .catch(err => {
        this.props.Loader();
        this.props.failMessage("Error occured");
        console.log(err);
      })
  }

  editHandler=(data)=>{
    console.log("edithandler",data);
    const updateState = {...this.state};
    updateState.pdfDetail['id'] = data['id'];
    updateState.pdfDetail['designName'] = data['design_name'];
    updateState.pdfDetail['description'] = data['description'];
    updateState.pdfDetail['isActive'] = data['is_active'];
    updateState.pdfDetail['isDefault'] = data['is_default'];
    updateState.pdfDetail['format'] = data['format'];
    updateState.pdfDetail['width'] = data['width'];
    updateState.pdfDetail['height'] = data['height'];

    updateState.pdfDetail['is_window'] = !data['variable_mapping'];
    updateState.pdfDetail['window_id'] = data['window_id'];

    updateState.createPDFModalOpen = true;
    this.setState(updateState);
  }

  windowsList = () => {
    const page = 0;//pagination.page; 
    // const orderBy = pagination.orderBy; 
    // const perPage = pagination.perPage; 
    const direction = '';//pagination.direction; 
    const search = '';//pagination.search;
    const {match} = this.props;
    const {params} = match;
    console.log('params',params);
    const queryString = '?query='+search+'&page='+page+'&orderBy=display_name&size=10000000&direction='+direction;
      callGET("windows/list/true/true"+queryString)
      .then(res => {
          const response = res.data;
          let windowsList = [];
          if(response.code===200){
            response.data.windows.content.map((arr,i) => {
                const value = {
                "label": arr.display_name,    
                "name": arr.display_name,
                "value": arr.id,
                }
                windowsList.push(value);
            })
          }
          this.setState({windowList:windowsList});
          
      }, (error) => {
          console.log(error);
      });
  }
}

export default withTranslation()(PDFList);